"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const component_context_1 = require("../context/component.context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.Body>
 *
 * Блок с контентом для SidePanel.
 */
const Body = ({ CoreSidePanel = side_panel_1.SidePanel.Content, dataTestId, greed = false, children, className, }) => {
    const { hasFooter, hasScroll } = (0, react_1.useContext)(component_context_1.SidePanelContext);
    const { setBodyGreed, isMobile, isResponsive } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    (0, react_1.useEffect)(() => {
        setBodyGreed(greed);
    }, [greed, setBodyGreed]);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    const contentProps = {
        className: (0, classnames_1.default)(index_module_css_1.default.component, platformStyles, {
            [index_module_css_1.default.hasFooter]: hasFooter,
            [index_module_css_1.default.hasScroll]: hasScroll,
            [index_module_css_1.default.greed]: greed,
        }, index_module_css_1.default.paddingTop, className),
        dataTestId,
    };
    return (0, jsx_runtime_1.jsx)(CoreSidePanel, Object.assign({}, contentProps, { children: children }));
};
exports.Body = Body;
